import React from 'react'
import { useIntl } from 'react-intl'
import cn from 'classnames'

import IconCheckmark from 'client/icons/Checkmark'

import styles from '../styles.module.css'
import DateIntl from 'src/comps/DateIntl'
import { DATE_INTL_FORMAT_MONTH_TEXT } from 'src/comps/DateIntl/constants'

import { Cancellation } from '..'
import { RatePaymentProps, RateProps } from '../RateSFL'

export interface RateNORProps {
  cancellation: Cancellation
}

export const RateNORPayment = ({ cancellationDate, payRate }: RatePaymentProps) => {
  const intl = useIntl()
  return payRate > 0 ? (
    <li className={cn(styles.greenIcon, styles.listDoted)}>
      <IconCheckmark size={16} /> {intl.formatMessage({ id: 'global.pay-now' })}
    </li>
  ) : (
    <li className={cn(styles.greenText, styles.listDoted)}>
      <IconCheckmark size={16} />
      {intl.formatMessage({ id: 'policies.pay-on' }, { date: cancellationDate })}
    </li>
  )
}

export const RateNORPaymentDescription = ({ cancellation, payRate, currency }: RateProps) => {
  const intl = useIntl()

  const cancellationDate = (
    <DateIntl value={cancellation?.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateNORPayment payRate={payRate} currency={currency} cancellationDate={cancellationDate} />
      </ul>
      <p>
        {payRate > 0
          ? intl.formatMessage({ id: 'reservation.non-refundable-offer' })
          : intl.formatMessage({ id: 'payment.no-prepayment' })}
      </p>
    </>
  )
}

export const RateNORCancelation = ({ cancellationDate }: { cancellationDate: JSX.Element }) => {
  const intl = useIntl()

  return (
    <li className={styles.greenText}>
      <IconCheckmark size={16} />
      {intl.formatMessage({ id: 'policies.free-cancellation-before' }, { date: cancellationDate })}
    </li>
  )
}

export const RateNORCancellationDescription = ({ cancellation }: RateNORProps) => {
  const intl = useIntl()

  const cancellationDate = (
    <DateIntl value={cancellation?.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateNORCancelation cancellationDate={cancellationDate} />
      </ul>
      <p>{intl.formatMessage({ id: 'payment.cancel-for-free-nor' }, { date: cancellationDate })}</p>
    </>
  )
}

const RateNOR = ({ cancellation, payRate, currency }: RateProps) => {
  const cancellationDate = (
    <DateIntl value={cancellation.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return payRate > 0 ? (
    <>
      <RateNORPayment payRate={payRate} currency={currency} cancellationDate={cancellationDate} />
      <RateNORCancelation cancellationDate={cancellationDate} />
    </>
  ) : (
    <>
      <RateNORCancelation cancellationDate={cancellationDate} />
      <RateNORPayment payRate={payRate} currency={currency} cancellationDate={cancellationDate} />
    </>
  )
}

export default RateNOR
